/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import { defineContainer } from './vue-component-lib/utils';

import type { JSX } from '@ovhcloud/ods-stencil/components/popover/custom-elements';

import { defineCustomElement as defineOsdsPopover } from '@ovhcloud/ods-stencil/components/popover/custom-elements/osds-popover.js';
import { defineCustomElement as defineOsdsPopoverContent } from '@ovhcloud/ods-stencil/components/popover/custom-elements/osds-popover-content.js';


export const OsdsPopover = /*@__PURE__*/ defineContainer<JSX.OsdsPopover>('osds-popover', defineOsdsPopover);


export const OsdsPopoverContent = /*@__PURE__*/ defineContainer<JSX.OsdsPopoverContent>('osds-popover-content', defineOsdsPopoverContent);

